import * as z from "zod";

export const PUSHABLE_FIELDS = [
  "returnFlow",
  "returnAddress",
  "returnShipping",
  "exchangeShipping",
  "coverage",
  "placementConfig",
  "infoModalConfig",
  "portalUI",
  "paymentMethod",
  "processingAutomation",
  "communications",
] as const;

export type PushableField = (typeof PUSHABLE_FIELDS)[number];

export const pushConfigurationToMerchant = {
  name: "pushConfigurationToMerchant" as const,
  input: z.object({
    merchantId: z.string(),
    fields: z.array(z.enum(PUSHABLE_FIELDS)).optional(),
    /** If true, sets teams.settings.returns.enabled = true (merchant goes live). Default: true */
    enableReturns: z.boolean().default(true),
    /** If true, pushes collected coverage config. If false, sets coverage.exchange/storeCredit/refund to false. Default: true */
    enableCoverage: z.boolean().default(true),
  }),
  output: z.object({ success: z.boolean() }),
};

export type PushConfigurationToMerchantInput = z.infer<
  typeof pushConfigurationToMerchant.input
>;
export type PushConfigurationToMerchantOutput = z.infer<
  typeof pushConfigurationToMerchant.output
>;
